import styled from 'styled-components';

export const Container = styled.div`
  width: 100%;
  height: 100%;
  background: #0f0f0f;

  display: flex;
  flex-direction: column;

  overflow: auto;

  @media (min-width: 768px) {
    padding: 20px;
  }

  @media (min-width: 1200px) {
    padding: 52px 57px 55px 31px;
  }
`;

export const Header = styled.header`
  align-items: center;
  justify-content: space-between;

  padding: 2rem;

  > button {
    max-width: none;
    margin-bottom: 1rem;
  }

  @media (min-width: 768px) {
    display: flex;

    padding: 0;

    > button {
      max-width: 32rem;
      margin-bottom: 0rem;
    }
  }
`;

export const ContentRight = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;

  width: 100%;
  height: 5rem;

  @media (min-width: 475px) {
    display: flex;
  }
`;

export const InputContainer = styled.div`
  background: #fff;

  width: 100%;

  height: 5rem;
  border-radius: 8rem;

  @media (min-width: 475px) {
    display: flex;
  }

  @media (min-width: 768px) {
    max-width: 42rem;
  }

  form {
    background: #fff;
    width: 100%;
    height: 5rem;
    border-radius: 8rem;
    flex: 1;

    display: flex;
    align-items: center;
    height: 100%;

    svg {
      &:first-child {
        margin-left: 2.5rem;
        margin-right: 0.8rem;
      }

      &:last-child {
        width: 4rem;
        height: auto;

        margin-right: 3rem;
        cursor: pointer;

        border-radius: 50%;

        transition: 180ms ease-in;

        :hover {
          background: #d3d3d3;
        }
      }
    }

    input {
      width: 100%;
      height: 100%;
      border: 0;

      font-size: 1.7rem;
      letter-spacing: 0.85px;
      line-height: 2.1rem;
      color: #000;

      &::placeholder {
        color: #000000;
      }
    }
  }
`;

export const ButtonExportReport = styled.a`
  display: flex;
  align-items: center;
  justify-content: center;

  background: linear-gradient(155deg, #ffdf22 0%, #ffd503 100%);
  width: 5rem;
  height: 5rem;
  border-radius: 5rem;

  margin-left: 1rem;

  position: relative;

  > svg {
    width: 2.8rem;
    height: 2.8rem;

    border-radius: 50%;
    .a {
      fill: #000000;
    }
  }

  > div {
    display: flex;
    align-items: center;
    justify-content: center;

    position: absolute;
    top: 5rem;
    right: 0;

    width: 18.7rem;
    height: 3.3rem;

    background: #ffffff;
    box-shadow: 0px 3px 6px #10101087;
    border-radius: 0.3rem;
    opacity: 0;
    transition: 300ms ease-in;
    margin-top: 0.5rem;

    pointer-events: visible;

    > p {
      font-size: 1.7rem;
      letter-spacing: 0.85px;
      line-height: 2.1rem;
      color: #000;
    }
  }

  &:hover {
    background: linear-gradient(155deg, #ffdf22d1 0%, #ffd503d1 100%);

    > div {
      opacity: 1;
      pointer-events: visible;
    }
  }
`;

export const ListStudents = styled.ul`
  display: grid;

  grid-template-columns: repeat(1, minmax(0, 1fr));
  column-gap: 1rem;
  row-gap: 1rem;

  margin-top: 2rem;

  padding: 0 2rem;

  @media (min-width: 768px) {
    grid-template-columns: repeat(2, minmax(0, 1fr));

    margin-top: 4rem;
    padding: 0;
  }

  @media (min-width: 1024px) {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }

  @media (min-width: 1440px) {
    column-gap: 5.2rem;
    row-gap: 5.2rem;
  }
`;

export const PaginateContainer = styled.div`
  padding: 0 2rem;

  @media (min-width: 768px) {
    padding: 0;
  }

  /* Pagination */
  .pagination {
    display: flex;
    justify-content: flex-end;
    list-style: none;
    outline: none;

    margin: 3.5rem 0;
  }

  .pagination > li > a {
    border: 1px solid #dcdcdc;
    padding: 1.2rem 1.5rem;
    outline: none;
    cursor: pointer;

    font-size: 1.3rem;
    color: #ffffff;

    &:hover {
      background: #ffffff;
      color: #0f0f0f;
    }
  }

  .pagination > .active > a,
  .pagination > .active > span,
  .pagination > .active > a:hover,
  .pagination > .active > span:hover,
  .pagination > .active > a:focus,
  .pagination > .active > span:focus {
    background-color: #ffffff;
    border: 1px solid #959595;
    color: #0f0f0f;
    font-weight: bold;
  }
  .pagination > li > a,
  .pagination > li > span {
    color: #9e9e9e;
  }
  .pagination > li:first-child > a,
  .pagination > li:first-child > span,
  .pagination > li:last-child > a,
  .pagination > li:last-child > span {
    border-radius: unset;
  }

  .previous,
  .break,
  .break-me {
    display: none;
  }

  .pagination > li:nth-child(2) > a {
    border-top-left-radius: 0.4rem;
    border-bottom-left-radius: 0.4rem;
  }

  .pagination > li:last-child > a {
    border-top-right-radius: 0.4rem;
    border-bottom-right-radius: 0.4rem;
  }
`;

export const ModalExportReportContent = styled.div`
  width: 100%;
  max-width: 48.7rem;
`;

export const ModalFilterContent = styled.div`
  width: 100%;
  max-width: 40rem;
`;

export const ModalTitle = styled.h1`
  font-size: 3.4rem;
  letter-spacing: 0.17rem;
  line-height: 2.9rem;
  text-transform: uppercase;
  color: #000000;

  text-align: center;
  margin-bottom: 4.1rem;
`;

export const ModalQuestion = styled.div`
  margin-bottom: 4.8rem;

  > h2 {
    font-weight: bold;
    font-size: 2rem;
    line-height: 1.3rem;
    color: #000000;

    text-align: center;
  }

  .radioOptions {
    display: flex;
    justify-content: center;

    margin-top: 1.3rem;
  }

  .checkboxOptions {
    width: 100%;
    max-width: 20rem;

    margin: 0 auto;
    margin-top: 2.2rem;
  }
`;

export const ModalQuestion2 = styled.div`
  width: 100%;
  max-width: 38.4rem;
  margin: 0 auto;

  > h2 {
    font-weight: bold;
    font-size: 2rem;
    line-height: 1.7rem;
    color: #000000;

    margin-left: 2rem;
  }

  .date_register {
    display: flex;
    width: 100%;

    margin: 0.8rem 0 2.3rem;

    > fieldset {
      border: none;
      display: flex;
      align-items: center;

      > label {
        font-weight: bold;
        font-size: 1.7rem;
        line-height: 1.7rem;
        color: #000000;

        margin-left: 2rem;
        margin-right: 1.1rem;
      }

      > input {
        width: 100%;
        height: 4.7rem;
        border-radius: 8rem;
        border: 0.2px solid #707070;
        padding-left: 2.2rem;

        font-size: 2rem;
        line-height: 1.7rem;

        &::-webkit-outer-spin-button,
        &::-webkit-inner-spin-button {
          -webkit-appearance: none;
          margin: 0;
        }

        & + input {
          margin-left: 1.2rem;
        }
        /* width: 12rem; */
      }
    }
  }

  .status {
    display: flex;

    margin: 1.3rem 4rem 3.5rem;
  }
`;

interface RadioOptionProps {
  isSelected: boolean;
}

export const RadioOption = styled.button<RadioOptionProps>`
  display: flex;
  align-items: center;
  background: none;

  & + & {
    margin-left: 3rem;
  }

  .radio {
    display: flex;
    align-items: center;
    justify-content: center;

    width: 2.2rem;
    height: 2.2rem;
    border: 0.8px solid #000;
    border-radius: 50%;

    background: transparent;

    margin-right: 0.5rem;

    transition: ${({ theme }) => theme.transition.default};

    .filled {
      width: 1.4rem;
      height: 1.4rem;
      border-radius: inherit;

      background: ${({ isSelected }) => (isSelected ? '#000' : '#fff')};
    }
  }

  > p {
    color: #000;
    transition: ${({ theme }) => theme.transition.default};
  }

  &:hover {
    .radio {
      border-color: #000;
    }

    > p {
      color: #000;
    }
  }
`;

interface CheckboxProps {
  isFilled: boolean;
}

export const Checkbox = styled.div<CheckboxProps>`
  display: flex;
  align-items: center;
  justify-content: center;

  background: #fff;

  border: 0.8px solid #000000;
  border-radius: 0.4rem;

  height: 2.8rem;
  min-width: 2.8rem;

  margin-right: 0.8rem;

  .filled {
    background: ${({ theme, isFilled }) =>
      isFilled ? theme.colors.black : theme.colors.white};

    height: 2.2rem;
    min-width: 2.2rem;

    border-radius: inherit;

    transition: 180ms ease-in;
  }
`;

export const CheckboxContainer = styled.div`
  display: flex;
  align-items: center;
  width: fit-content;

  margin-bottom: 0.8rem;

  cursor: pointer;

  &:hover {
    ${Checkbox} {
      .filled {
        background: #000;
      }
    }
  }
`;

export const AlertContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;

  flex: 1;

  > h1 {
    color: #ffdf22;
  }
`;

export const ResetFilterContainer = styled.div`
  margin-bottom: 1rem;
  display: flex;
  align-items: center;
  justify-content: flex-end;

  svg {
    cursor: pointer;
  }
`;
